export default __webpack_public_path__ + "static/media/icon-parking-outline.d0d58f56.svg";